import { render, staticRenderFns } from "./Mandula.vue?vue&type=template&id=ab53ba40&scoped=true"
import script from "./Mandula.vue?vue&type=script&lang=js"
export * from "./Mandula.vue?vue&type=script&lang=js"
import style0 from "./Mandula.vue?vue&type=style&index=0&id=ab53ba40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab53ba40",
  null
  
)

export default component.exports